import { useLayoutEffect } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { SectionTitle } from "../components/SectionTitle";
import {
  DescentFaqSection,
  DescentPageLink,
  LinkArrow,
  LinkLabel,
  NavLinkWrap,
} from "../components/DescentFaqSection";
import {
  ContentArea,
  SessionPageContainer,
} from "../components/SessionPageComponents";

const DESCENT_EMAIL = "mayamistress@protonmail.com";

export const TheDescentFaqPage = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>The Descent Q&A | Maya Mistress</title>
        <meta
          name="description"
          content="Questions and answers about The Descent by Maya Mistress."
        />
        <meta
          name="keywords"
          content="The Descent Q&A, Maya Mistress, FemDom, submission, power dynamics"
        />
      </Helmet>

      <SessionPageContainer>
        <ContentArea>
          <SectionTitle title="Q&A" backdropText="Descent" />
          <DescentFaqSection />
          <NavLinkWrap $margin="3rem 0 0">
            <StillHaveQuestions>
              Still got questions?{" "}
              <EmailLink href={`mailto:${DESCENT_EMAIL}`}>
                Send me an email.
              </EmailLink>
            </StillHaveQuestions>
          </NavLinkWrap>
          <NavLinkWrap $margin="4rem 0 2rem">
            <DescentPageLink to="/the-descent">
              <LinkArrow $leading>←</LinkArrow>
              <LinkLabel>Back to The Descent</LinkLabel>
            </DescentPageLink>
          </NavLinkWrap>
        </ContentArea>
        <br />

        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </SessionPageContainer>
    </>
  );
};

const StillHaveQuestions = styled.p`
  margin: 0;
  font-family: "Ysabeau Office", sans-serif;
  font-size: 1.05rem;
  line-height: 1.7;
  color: rgba(239, 233, 225, 0.75);

  @media screen and (max-width: 600px) {
    font-size: 1rem;
  }
`;

const EmailLink = styled.a`
  color: var(--color-bone);
  text-decoration: underline;
  text-underline-offset: 0.2em;
  transition: opacity 200ms ease;

  &:hover {
    opacity: 0.75;
  }
`;
